import React, { useEffect, useState } from "react";

export default function ReaderControls({ page, pageCount, onPageChange, label }) {
  const [jump, setJump] = useState(String(page));

  useEffect(() => setJump(String(page)), [page]);

  const goToJump = (event) => {
    event.preventDefault();
    const requested = Number.parseInt(jump, 10);
    if (!Number.isFinite(requested)) {
      setJump(String(page));
      return;
    }
    onPageChange(Math.min(pageCount, Math.max(1, requested)));
  };

  return (
    <div className="xs-reader-controls" aria-label={`${label} page controls`}>
      <button type="button" onClick={() => onPageChange(page - 1)} disabled={page <= 1}>
        previous
      </button>
      <span className="xs-reader-page-status" aria-live="polite">
        page {page} of {pageCount}
      </span>
      <button type="button" onClick={() => onPageChange(page + 1)} disabled={page >= pageCount}>
        next
      </button>
      <form onSubmit={goToJump} className="xs-reader-jump">
        <label>
          <span>jump</span>
          <input
            type="number"
            min="1"
            max={pageCount}
            value={jump}
            onChange={(event) => setJump(event.target.value)}
            inputMode="numeric"
          />
        </label>
        <button type="submit">go</button>
      </form>
    </div>
  );
}
